<template>
<div class="row mb-2 px-2 paragraph-indent">
	<i>Можна передавати <b>не більше</b> одного запиту телекерування одночасно. Якщо зараз опрацовуеться запит - будьласка зачекайте закінчення процедури обробки запиту (стан запиту "Записано успішно" або одна з помилок).</i>
</div>

<!-- <div v-if="station" class="row g-0"> -->
<div class="row row-cols-1 row-cols-xxl-2 g-3">
	<div
		v-if="isSupportedStartStop"
		class="col p-0"
	>
		<div class="half-transparent-border m-2 px-2">
			<start-stop-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
			/>
		</div>
	</div>
	<div
		v-else
		class="col d-none d-xxl-block p-1 m-0"
	>
		<div class="half-transparent-border m-2 px-2">
			&nbsp;
		</div>
	</div>

	<div class="col p-0">
		<div class="half-transparent-border m-2 px-2">
			<service-unit-time-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
			/>
		</div>
	</div>

	<div class="col p-0">
		<div class="half-transparent-border m-2 px-2">
			<set-stabilization-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
			/>
		</div>
	</div>

	<div class="col p-0">
		<div class="half-transparent-border m-2 px-2">
			<power-counter-value-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
			/>
		</div>
	</div>

	<div class="col p-0">
		<div class="half-transparent-border m-2 px-2">
			<measure-potential-on-off-station-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
			/>
		</div>
	</div>

	<div class="col p-0">
		<div class="half-transparent-border m-2 px-2">
			<perform-survey-form
				:stationId="station.id"
				:isEnabled="accountStore.permissions.includes('dispatch_stations')"
			/>
		</div>
	</div>
</div>

<div class="row g-0">
</div>

<div class="row g-0 m-0 p-0 mt-3">
	<h6>Стан запиту</h6>
	<rpc-table
		:stationId="stationId"
		:filterJobs="jobsFilter"
		height="270"
		class="m-0 p-0 g-0"
	/>
</div>
</template>




<script>
import SetStabilizationForm from './SetStabilizationForm.vue'
import PowerCounterValueForm from "./PowerCounterValueForm.vue"
import MeasurePotentialOnOffStationForm from './MeasurePotentialOnOffStationForm.vue'
import PerformSurveyForm from './PerformSurveyForm.vue'
import StartStopForm from './StartStopForm.vue'
import ServiceUnitTimeForm from './ServiceUnitTimeForm.vue'
import RpcTable from './RpcTable.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore'
import { rpcTaskSchema, stationManageJobs } from '@/composables/rpcTasks.js'
import { Station } from '@/models/station.js'
import { PowerUnit } from '@/models/powerUnit.js'


export default {
	components: {
		SetStabilizationForm,
		PowerCounterValueForm,
		MeasurePotentialOnOffStationForm,
		PerformSurveyForm,
		StartStopForm,
		ServiceUnitTimeForm,
		RpcTable,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const jobsFilter = stationManageJobs

		return {
			rpcTaskSchema,
			jobsFilter,
			accountStore,
			stationsStore,
			Station,
		}
	},

	data() {
		return {}
	},

	created() {},
	
	methods: {},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },

		isSupportedStartStop () {
			// If no power unit (undefined)
			if (!this.station.passport.has(Station.passportKeys.powerUnit.self)) {
				return false
			}

			return [
				PowerUnit.versions.v2017,
				PowerUnit.versions.v2022,
				PowerUnit.versions.v2025,
				PowerUnit.versions.v2025t,
				PowerUnit.versions.mcps,
			].includes(this.station.passport.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.unitVersion])
		}
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style scoped>
	.form-title {
		font-weight: bold;
		line-height: 1.16;
		letter-spacing: 0em;
		font-size: 1rem;
	}

	.half-transparent-border {
		min-width: 35em;
		min-height: 5em;
		max-height: 40em;
		height: 100%;
	}
</style>